import { render, staticRenderFns } from "./DraggableListDraggable.vue?vue&type=template&id=9e623cfe&scoped=true&"
import script from "./DraggableListDraggable.vue?vue&type=script&lang=js&"
export * from "./DraggableListDraggable.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListDraggable.vue?vue&type=style&index=0&id=9e623cfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e623cfe",
  null
  
)

export default component.exports